export const environment = {
  production: false,
  environment: 'dev',
  useAppCheckDebugToken: false, // Prevent debug tokens in deployed dev
  firebase: {
    apiKey: "AIzaSyBK1ZwR0m_3q0UYsPl4FnkFW5cvx6J99Rc",
    authDomain: "up-forsale-viewer-dev.firebaseapp.com",
    projectId: "up-forsale-viewer-dev",
    storageBucket: "up-forsale-viewer-dev.firebasestorage.app",
    messagingSenderId: "112792682376",
    appId: "1:112792682376:web:c4ffb7948883803416443d",
    measurementId: "G-F71ZR6RZ81"
  },
  appCheck: {
    // reCAPTCHA Enterprise site key
    siteKey: "6Le_qS8sAAAAAP_EHm4MjWIjPfkpcVK4ZGzV0b6j"
    // Note: For localhost development, App Check will automatically generate a debug token
    // Check the browser console for: "App Check debug token: <token>"
    // Add this token to Firebase Console > App Check > Apps > [Your App] > Debug tokens
  },
  api: {
    baseUrl: "https://australia-southeast1-up-forsale-data-dev.cloudfunctions.net"
  },
  loadBalancer: {
    // HTTPS Load Balancer URLs for Cloud Armor protection
    // Using domain (requires DNS configuration and SSL certificate provisioning)
    viewerDev: "https://australia-southeast1-up-forsale-viewer-dev.cloudfunctions.net"
  }
};






